const PREFIX = "ROLE_PERMISSION_";

export const ROLE_SUPER_ADMIN = "ROLE_SUPER_ADMIN";
export const ROLE_PERMISSION_USER_MANAGEMENT = PREFIX + "USER_MANAGEMENT";
export const ROLE_PERMISSION_VEHICLE_VIEW_DETAILS =
  PREFIX + "VEHICLE_VIEW_DETAILS";
export const ROLE_PERMISSION_VEHICLE_MANAGEMENT = PREFIX + "VEHICLE_MANAGEMENT";
export const ROLE_PERMISSION_VEHICLE_DATA_FEED = PREFIX + "VEHICLE_DATA_FEED";
export const ROLE_PERMISSION_DICTIONARIES_MANAGEMENT =
  PREFIX + "DICTIONARIES_MANAGEMENT";
export const ROLE_PERMISSION_ISSUE_CREATE = PREFIX + "ISSUE_CREATE";
export const ROLE_PERMISSION_ISSUE_CHANGE_STATUS =
  PREFIX + "ISSUE_CHANGE_STATUS";
export const ROLE_PERMISSION_ISSUE_AUTOMATIC = "ISSUE_AUTOMATIC";
export const ROLE_PERMISSION_SERVICE_REPORT_CREATE =
  PREFIX + "SERVICE_REPORT_CREATE";
export const ROLE_PERMISSION_SERVICE_REPORT_EDIT =
  PREFIX + "SERVICE_REPORT_EDIT";
export const ROLE_PERMISSION_SERVICE_REPORT_DELETE =
  PREFIX + "SERVICE_REPORT_DELETE";
export const ROLE_PERMISSION_ISSUE_FINNISH = PREFIX + "ISSUE_FINNISH";
export const ROLE_PERMISSION_REVIEW_REPORT_CREATE =
  PREFIX + "REVIEW_REPORT_CREATE";
export const ROLE_PERMISSION_REVIEW_REPORT_EDIT = PREFIX + "REVIEW_REPORT_EDIT";
export const ROLE_PERMISSION_REVIEW_REPORT_DELETE =
  PREFIX + "REVIEW_REPORT_DELETE";
export const ROLE_PERMISSION_COMPREHENSIVE_REPORT_GENERATE =
  PREFIX + "COMPREHENSIVE_REPORT_GENERATE";
export const ROLE_PERMISSION_ISSUE_FETCH_STATUS_HISTORY =
  PREFIX + "ISSUE_FETCH_STATUS_HISTORY";
export const ROLE_PERMISSION_SPARE_PART_MANAGEMENT =
  PREFIX + "SPARE_PART_MANAGEMENT";
export const ROLE_PERMISSION_SPARE_PART_VIEW = PREFIX + "SPARE_PART_VIEW";
